import Button from '../../button/Button';

export default function DeskSliderContent({ 
  leftHeader, 
  centerHeader, 
  rightHeader, 
  leftText, 
  slideNumber, 
  imgUrl, 
  rightText, 
  cta, 
  ctaLink,
  ctaOnClick,
}) {
    return (
        <div>
            <div className="flex items-start justify-center title-slider">
              <div className="w-1/4 slide-item">
                <div className="overflow-title">
                  <h1 className="font-bold outside-header">{leftHeader}</h1>
                </div>
              </div>
              <div className="w-1/2 slide-item slide-active">
                <div className="active-title text-center">
                  <h1 className="lt-white font-bold">{centerHeader}</h1>
                </div>
              </div>
              <div className="w-1/4 slide-item">
                <div className="overflow-title">
                  <h1 className="font-bold outside-header">{rightHeader}</h1>
                </div>
              </div>
            </div>
            <div className="flex items-start justify-center content-slider">
              <div className="w-1/4 slide-item">
                <div className="slide-desc left">
                  <p>{leftText}</p>
                </div>
                <div className="slide-number">
                  <div className="flex items-center">
                    <h2 className="current-slide-num">{slideNumber}</h2>
                    <h3 className="total-slide-num">/ 03</h3>
                  </div>
                </div>
              </div>
              <div className="w-1/2 slide-item slide-active">
                <div className="active-image text-center">
                  <div className="active-graphic">
                    <img src={imgUrl} alt={centerHeader} />
                  </div>
                </div>
              </div>
              <div className="w-1/4 slide-item">
                <div className="slide-desc right">
                  <p>{rightText}</p>
                  {ctaLink && (
                    <a className="track-mint" href={ctaLink}>{cta}</a>
                  )}
                  {ctaOnClick && (
                    <Button
                      variant="Outline"
                      className="border-[#3772FF]"
                      onClick={ctaOnClick}
                    >
                      {cta}
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
    )
}